module.exports = __webpack_public_path__ + "static/media/img_step.0e469e84.png";